export default {
  getList: {
    method: 'post',
    url: '/client/partner/business-opportunity/cooperatorId/list'
  },
  getDetail: {
    method: 'get',
    url: '/client/partner/business-opportunity/cooperatorId/detail/ID'
  },
  create: {
    method: 'post',
    url: '/client/partner/business-opportunity/cooperatorId/create'
  },
  replicate: {
    method: 'post',
    url: '/client/partner/business-opportunity/cooperatorId/replicate'
  },
  update: {
    method: 'put',
    url: '/client/partner/business-opportunity/cooperatorId/update/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/partner/business-opportunity/cooperatorId/delete/ID'
  },
  archive: {
    method: 'delete',
    url: '/client/partner/business-opportunity/archive'
  },
  restore: {
    method: 'put',
    url: '/client/partner/business-opportunity/restore'
  },
  makeCopy: {
    method: 'post',
    url: '/client/partner/business-opportunity/cooperatorId/make-copy/ID'
  },
  find: {
    method: 'get',
    url: '/client/partner/business-opportunity/cooperatorId/find?key=KEY'
  },
  timeCompletePositions: {
    method: 'post',
    url: '/client/partner/business-opportunity/cooperatorId/time-complete-positions'
  }
}
